<div #chargeList class="chargeList" *ngIf="  firstReturn">
    <!-- (pageLength>0) && -->
    <div class="records" [class.justify-content-flex-start]="!showDropoff">
        <mat-form-field appearance="outline" fxFlex="17em">
            <input matInput (keyup)="applyFilter($event)" placeholder="Search">
            <i class="flaticon-search" matSuffix></i>
        </mat-form-field>
        <div
            [matTooltip]="transactionType == 'supply' ? 'Marking drop-off not available for Supply Requests, Mark drop-off for Use requests and this page will be updated automatically.' : ''">
            <button mat-raised-button [class]="transactionType != 'supply' ? 'addBtn clickIt' : ''"
                (click)="AddDropoff()" *ngIf="showDropoff && !isCustomer" [disabled]="transactionType == 'supply'">Add
                Drop-off</button>
        </div>
    </div>
    <div class="title">
        <div class="t1 t1pl">
            <span class="desc"> Container Drop-off details: </span>
        </div>
        <logzy-chipper [label]="' Pending For Drop-off '"
            [value]="returnDetailsRequest?.pending_return_drop_off_quantity"></logzy-chipper>
    </div>
    <!-- <logzy-table-loader *ngIf="loading"></logzy-table-loader> -->
    <div class="setTable" >
        <mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)" >
            <ng-container matColumnDef="container_number">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="container_number"
                    sortActionDescription="Container Number">
                    Container No
                </th>
                <td mat-cell *matCellDef="let element" class="m-card-title" data-label="ContainerNo">
                    <b>{{ element?.container?.container_number }}</b>
                </td>
            </ng-container>

            <ng-container matColumnDef="container_size_type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Size</th>
                <td mat-cell *matCellDef="let element" class="m-card-sub-title" data-label="Size">
                    {{ element?.container?.container_size_type }}
                </td>
            </ng-container>

            <ng-container matColumnDef="ownership">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Ownership
                </th>
                <td mat-cell *matCellDef="let element" class="has_label_on_mobile" data-label="Ownership">
                    {{ element?.container?.ownership + (element?.container?.ownership == 'Forwarding' ? '(' +
                    element?.stock_owner?.name + ')' : '')}}
                </td>
            </ng-container>
            <ng-container matColumnDef="pickup_date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Pick-up Date
                </th>
                <td mat-cell *matCellDef="let element" class="has_label_on_mobile" data-label="Pick-up Date">
                    {{ element?.pickup_date | date : "dd MMM, yyyy" }}
                </td>
            </ng-container>
            <ng-container matColumnDef="pickup_depot">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Pick-up Depot
                </th>
                <td mat-cell *matCellDef="let element" class="has_label_on_mobile" data-label="Pick-up Depot">
                    {{ element?.pickup_depot?.display_name | titlecase }}
                </td>
            </ng-container>
            <ng-container matColumnDef="return_reference_no">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Return Reference No
                </th>
                <td mat-cell *matCellDef="let element" class="has_label_on_mobile" data-label="Return Reference No">
                    {{
                    element?.return_details?.return_reference_no
                    ? element?.return_details?.return_reference_no
                    : "-"
                    }}
                </td>
            </ng-container>
            <ng-container matColumnDef="dropoff_date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Drop-off Date
                </th>
                <td mat-cell *matCellDef="let element" class="has_label_on_mobile" data-label="Drop-off Date">
                    {{
                    element?.return_details?.dropoff_date
                    ? (element?.return_details?.dropoff_date
                    | date : "dd MMM, yyyy")
                    : "-"
                    }}
                </td>
            </ng-container>
            <ng-container matColumnDef="dropoff_depot">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Drop-off Depot
                </th>
                <td mat-cell *matCellDef="let element" class="has_label_on_mobile" data-label="Drop-off Depot">
                    {{
                    element?.return_details?.dropoff_depot?.display_name
                    ? (element?.return_details?.dropoff_depot
                    ?.display_name | titlecase)
                    : "-"
                    }}
                </td>
            </ng-container>
            <!-- <ng-container matColumnDef="user_remark">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Remarks
                </th>
                <td mat-cell *matCellDef="let element" class="has_label_on_mobile" data-label="Remarks">
                    {{
                    element?.return_details?.user_remark
                    ? element?.return_details?.user_remark
                    : "-"
                    }}
                </td>
            </ng-container> -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </mat-table>
        <ng-container *ngIf="billuLoader ">
            <logzy-billu [part1]="part1 " [part2]="part2 " [part3]="part3" font="14px"></logzy-billu>
        </ng-container>
        <div class="loadingData" [class.d-none]="!update">
            <logzy-gear-loader></logzy-gear-loader>

        </div>
        <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 25, 100]" showFirstLastButtons aria-label="Select page">
        </mat-paginator>
    </div>
</div>
<!-- </div> -->

<div class="returnOrder" *ngIf="PickupContainer">
    <div class="title">
        <div class="t1">
            <!-- <span> Return</span> -->
            <title-back [addTitle]="true" [Title]="'Return'" (back)="backtoList()"></title-back>
            <span class="desc updatetitle">Select Return Reference</span>
        </div>
        <div class="t2">
            <mat-chip *ngFor="let item of requestService.selectedRequest?.requirement"
                class="primary-chip sleek-chip container-chip">
                {{ item?.quantity }}*{{
                item?.container_size_type?.display
                }}
                ({{ item?.condition?.value }})
            </mat-chip>
            <logzy-chipper [label]="' Pending For Drop-off '"
                [value]="returnDetailsRequest?.pending_return_drop_off_quantity"></logzy-chipper>
        </div>
    </div>
</div>
<ng-container *ngIf="PickupContainer">

    <!-- <div class="inputs" style="    display: flex;
    flex-wrap: wrap;" *ngIf="cardLoader">
        <logzy-card-loader [type2]="true"></logzy-card-loader>
        <logzy-card-loader [type2]="true"></logzy-card-loader>
        <logzy-card-loader [type2]="true"></logzy-card-loader>
        <logzy-card-loader [type2]="true"></logzy-card-loader>
    </div> -->
    <mat-radio-group class="inputs" fxLayout="row wrap" id="returnContainer" *ngIf="!billuLoader">
        <ng-container *ngFor="let item of returnList; let index = index">
            <mat-radio-button value="{{item.return_reference_no}}" *ngIf="!(item.status=='Cancelled')"
                (click)="select(item,index)" [class.mat-radio-checked]="index == selectedIndex"
                [class.radioDOQ0]="!item.remaining_dropoff_quantity" [disabled]="!item.remaining_dropoff_quantity">
                <div class="pickupCard">
                    <div class="head">
                        <span class="releaseNo">{{item.return_reference_no}}</span>
                        <mat-chip class="headchip" selected>{{
                            item.requirement.container_size_type.display }} | Drop-off
                            pending:{{item.remaining_dropoff_quantity == null?
                            "0":
                            item.remaining_dropoff_quantity}}/{{item.quantity == null ? "0" : item.quantity}}</mat-chip>
                    </div>
                    <div fxLayout="column">
                        <div class="depotName">
                            <i class="flaticon-anchor"></i>
                            <span>{{ item.depot?.display_name }}</span>
                        </div>
                        <div class="address">
                            <span>{{ item.depot?.address }} </span>
                        </div>
                    </div>
                    <div class="foot">
                        <span class="validity">Valid till
                            {{ item.valid_till | date : "dd MMM, yyyy" }}</span>
                        <mat-chip class="footchip">{{ item.do_owner?.value }}</mat-chip>
                    </div>
                </div>
            </mat-radio-button>
        </ng-container>
    </mat-radio-group>
    <div *ngIf="billuLoader1">
        <logzy-billu [button]="createReturn" [part1]="part11" [part2]="part12" [part3]="part13" (action1)="navigatePickup()" font="14px"></logzy-billu>
    </div>
</ng-container>

<ng-container *ngIf="showContainersList">
    <div class="t1 m-t-15 t1p">
        <span class="desc">
            Select the containers from the list and select Return date
        </span>
    </div>
    <div class="inputs pl05em" fxLayout="row wrap" id="returnForm">
        <!-- <logzy-multiselect-autocomplete [returnId]="returnId" (selectedContainers)="getSelectedContainers($event)"
            fxFlex="50%" fxLayout="column" [errors]="errorObj.container_numbers"></logzy-multiselect-autocomplete> -->


        <logzy-containerslistforreturn [containersList]="containersList" fxFlex="40em"
            [returnId]="returnId"></logzy-containerslistforreturn>


        <div fxFlex="12em" fxLayout="column">
            <span class="inputTitle">Return Date*</span>
            <app-date-field [isEditable]="true" [maxDate]="currentDate" [(ngModel)]="dropDate"
                [errors]="errorObj.dropoff_date"></app-date-field>
        </div>
        <div fxFlex="12em" fxLayout="column">
            <span class="inputTitle">Return Remarks</span>
            <app-text-field [isMultiline]="true" [isEditable]="true" [(ngModel)]="remarks" [name]="'remarks'" class=""
                fxLayout="column">
            </app-text-field>
        </div>
        <div fxFlex="12em" fxLayout="column" *ngIf="requestService.selectedRequest?.request_type?.dev_name=='lease'">
            <span class="inputTitle"> Ports</span>
            <app-mat-auto-search [isEditable]="true" [(ngModel)]="port"
                [name]="'hsn_code'" [listUrl]="port_url + 'location/?depot_id=' + selectRR.depot?.id + '&search=::search::'" [displayField]="'name_display'"
                fxFlex="14.3em" fxLayout="column" [errors]="errorObj.port" class="align-items-center">
            </app-mat-auto-search>
        </div>

        <div fxFlex="100" class="reviewBtn">
            <button mat-raised-button class="Save" [disabled]="disableReturnButton"
                (click)="postReturnContainerDropOff()">
                <span *ngIf="!disableReturnButton">Save Return
                    Details</span>
                <div *ngIf="disableReturnButton" class="p03">
                    <i class="flaticon-loading spin"></i>
                    <span>Saving...</span>
                </div>
            </button>
        </div>
    </div>
</ng-container>